import React from 'react';
import { Users } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';

/**
 * Empty-state CTA (industry-standard onboarding pattern, plan F10) for an AM
 * whose managed-accounts pool is empty. Renders inside the terminal when
 * `summary.pool_count === 0`.
 */
const EmptyPoolPanel: React.FC<{ isSuperAdmin: boolean }> = ({ isSuperAdmin }) => (
  <Card>
    <CardContent>
      <div className="text-center py-12">
        <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          No managed users in your pool yet
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 max-w-md mx-auto">
          Once a SuperAdmin assigns Zebu users to your pool, this terminal will
          show their login status, open positions, subscriptions, and live error
          feed in one place.
        </p>
        {isSuperAdmin && (
          <p className="text-sm text-blue-600 dark:text-blue-400 mt-3">
            <a href="/admin/super/managed-users" className="hover:underline">
              Open SuperAdmin → Managed Users
            </a>{' '}
            to attach users to an AM's pool.
          </p>
        )}
      </div>
    </CardContent>
  </Card>
);

export default EmptyPoolPanel;
